import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const CustomDialog = ({
  isOpen, 
  open,
  onClose, 
  children,
  title = '',
  fullWidth = false,
  maxWidth = 'sm',
  actionButtons = [],
  showCloseButton = true,
  backgroundColor = '#ffffff',
}) => {
  console.log('CustomDialog', {isOpen, title});
  const _isOpen = isOpen || open;
  return (
    <Dialog 
      open={_isOpen} 
      onClose={onClose} 
      maxWidth={maxWidth} 
      fullWidth={fullWidth}
    >
      <DialogTitle style={{backgroundColor}}>
        <Stack direction='row' spacing={2} alignItems='center' justifyContent='space-between'>
          <Stack direction='row' spacing={1} justifyContent='center' style={{flexGrow: 1}}>
            <Typography variant='h2' style={{paddingLeft: '1.5em'}}>{title}</Typography>
          </Stack>
          {showCloseButton && 
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          }
        </Stack>
      </DialogTitle>
      <DialogContent style={{backgroundColor}}>
        {children}
      </DialogContent>
      <DialogActions style={{backgroundColor}}>
        {(actionButtons || []).map(Button => (<Button />))}
      </DialogActions>
    </Dialog>
  );
};

export default CustomDialog;

